import { useAccountCapabilities } from '@/composables/useAccountCapabilities'

type ContractViewerHire = {
  recruiterManagesWorkers?: boolean | null
  viewerIsSupplier?: boolean | null
  supplierSignatureWaived?: boolean | null
}

/**
 * Does the viewer confirm (accept) the contract on this hire? Worker yes
 * (unless managed by an SA), supplier yes (when they manage the worker). The
 * hire must include `viewerIsSupplier` — recruiter capability alone isn't
 * enough.
 */
export function useViewerConfirmsContract() {
  const { isWorker } = useAccountCapabilities()

  return (hire: ContractViewerHire) => {
    if (isWorker.value) return hire.recruiterManagesWorkers !== true
    if (hire.viewerIsSupplier) return hire.recruiterManagesWorkers === true
    return false
  }
}

/**
 * Does the viewer place a signature on the contract? Confirming, minus the
 * signature-free supplier confirmation (JIRA-17526): when the MSP has waived
 * the supplier signature, the supplier still confirms but does not sign. The
 * worker's own signature is never waived.
 */
export function useViewerSignsContract() {
  const { isWorker } = useAccountCapabilities()
  const confirms = useViewerConfirmsContract()

  return (hire: ContractViewerHire) =>
    confirms(hire) && (isWorker.value || hire.supplierSignatureWaived !== true)
}
